import { createListStore } from './useListStore'

export const useOrdersStore = createListStore() 